import { P2GLink, P2GLinkGroup } from '@parcel2go/core-ui';
import { Fragment, ReactNode } from 'react';
import { EditType } from './EditType';
import { ErrorCodeButtonText, ErrorCodeTranslationKey } from './ErrorCodeButtonText';
import { ErrorCodeResolutionAction } from './ErrorCodeResolutionAction';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { sanitiseKey } from '~/lib/utils/translation';
import { useTaxName } from '@parcel2go/npm-p2g-app';

interface props {
  errors: string[];
  edit: (type: EditType) => void;
  controls?: { [key: string]: ReactNode };
  limit: number;
  children?: ReactNode;
}
const ErrorSummary: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const taxName = useTaxName();

  if (!props.errors || props.errors.length === 0 || props.limit < 1) {
    return props.children ? <>{props.children}</> : null;
  }

  function onclick(x: string) {
    const action = ErrorCodeResolutionAction(x);
    if (action) {
      props.edit(action);
    }
  }

  const messages = props.errors.slice(0, props.limit);

  return (
    <P2GLinkGroup
      links={messages.map((message) => (
        <Fragment key={message}>
          {props.children || (
            <P2GLink onClick={() => onclick(message)}>
              {t(sanitiseKey(ErrorCodeTranslationKey(message)), {
                defaultValue: ErrorCodeButtonText(message),
                taxName: taxName
              })}
            </P2GLink>
          )}
          {props.controls && props.controls[message] && <>&nbsp;({props.controls[message]})</>}
        </Fragment>
      ))}
    />
  );
};

export default ErrorSummary;
